<script setup lang="ts">
import Breadcrumbs from '@/Components/Breadcrumbs.vue'
import ApplicationHead from '@/Components/Layout/ApplicationHead.vue'
import { useHelpers } from '@/Composables/helpers'
import QuickLinks from './Partials/QuickLinks.vue'

defineProps<{
    title: string,
    content: string,
    noindex?: boolean,
}>()

const { asset } = useHelpers()
</script>

<template>
    <div>
        <ApplicationHead :title="title">
            <meta property="og:type" content="website">
            <meta property="og:image" :content="asset('/images/social-logo.png')">
        </ApplicationHead>

        <Breadcrumbs />

        <div class="px-4 py-16 mx-auto bg-white max-w-7xl sm:px-6 lg:px-8">
            <article class="prose max-w-none">
                <h1>{{ title }}</h1>
                <div v-html="content"></div>
            </article>

            <QuickLinks class="mt-10" />
        </div>
    </div>
</template>
